export const HIDEABLE_ELEMENTS = [
  'mono-hidden',
  'mono-hidden-visually',
  'mono-alert',
];
